import React, { useEffect, useContext, useRef } from "react";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import ReplayIcon from "@mui/icons-material/Replay";
import RefreshIcon from "@mui/icons-material/Refresh";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { Box, FormControl, MenuItem, Select } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useLocation, useNavigate } from "react-router-dom";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import ProductVersionDropdown from "../common/ProductVersionDropdown";
import NoProductMessage from "../../utils/common/NoProductMessage";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_SUPERADMIN,
  ROLE_USER_MANAGER,
} from "../../model";

import ChatMetricIssuesTable from "../cuvo-metrics-dashboard/ChatMetricIssuesTable";

import ChatMetricsTileCount from "../cuvo-metrics-dashboard/ChatMetricsTileCount";
import ChatDevices from "../cuvo-metrics-dashboard/ChatDevices";
import ChatIssuesStatusChart from "../cuvo-metrics-dashboard/ChatIssuesStatusChart";
import ChatBotKBEffiencyGraph from "../cuvo-metrics-dashboard/ChatBotKBEffiencyGraph";
import TickMetricFirstResponse from "./TickMetricFirstResponse";
import TickMetricMeanTimeResolution from "./TickMetricMeanTimeResolution";
import TickMetricAIAssist from "./TickMetricAIAssist";
import TicketMetricCSMActivity from "./TicketMetricCSMActivity";

import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { CSVLink } from "react-csv";

import images from "../../global-styles/images";
import { ec2HostURL } from "../../utils/config";
// import { getFilteredByTimeStamp } from "../../utils/common/common";
const feedbacks = [
  {
    id: 1,
    ticketNumber: 26398,
    userFeedback: "The picture is not displaying properly",
    status: "pending",
    userCount: "+36k",
  },
  {
    id: 2,
    ticketNumber: 26398,
    userFeedback: "Disturbing grainy images ",
    status: "open",
    userCount: "+67",
  },
  {
    id: 3,
    ticketNumber: 342765,
    userFeedback: "Unable to see images properly",
    status: "replied",
    userCount: "+12",
  },
  {
    id: 4,
    ticketNumber: 143212,
    userFeedback: "Image quality is too poor",
    status: "closed",
    userCount: "+83",
  },
];

function ReportsTicketsDashboardContent(props: any) {
  const {
    userInfo,
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    contextProVersion,
    setcontextProVersion,
    contextRedirectProdPage,
    setContextMetricPageStartDate,
    setContextMetricPageEndDate,
    ContextMetricPageStartDate,
    ContextMetricPageEndDate,
  } = useContext(UserContext) as UserLoginInfo;
  const location = useLocation();
  appLogger.info({
    infoObj: {
      method: "DashboardContent",
      component: "dashboard",
      fileName: "index.tsx",
      location: location,
    },
  });
  const currDate = new Date();
  const stDate = new Date(currDate);
  stDate.setHours(0, 0, 0, 0);
  currDate.setHours(23, 59, 59, 999);
  let stDateTimestamp: any = "";
  let currDateTimestamp: any = "";

  stDate.setMonth(currDate.getMonth() - 1);
  stDate.setDate(stDate.getDate() + 1);
  if (stDate && currDate) {
    stDateTimestamp = stDate.getTime();
    currDateTimestamp = currDate.getTime();
  }

  const [product, setProduct] = React.useState("");
  const [selectedProduct, setSelectedProduct] = React.useState<any>();
  const [productResponse, setProductResponse] = React.useState([] as any);
  const [version, setVersion] = React.useState("");
  // const [userData, setUserData] = React.useState([] as any);
  const [startDateValue, setStartDateValue] = React.useState(
    ContextMetricPageStartDate ? ContextMetricPageStartDate : stDateTimestamp
  );
  const [endDateValue, setEndDateValue] = React.useState(
    ContextMetricPageEndDate ? ContextMetricPageEndDate : currDateTimestamp
  );
  const [selectedProVerData, setselectedProVerData] = React.useState([] as any);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isChatbotMetricsLoading, setIsChatbotMetricsLoading] =
    React.useState(false);
  const [proVerUrl, setproVerUrl] = React.useState("");
  const [reportsTicketsData, setReportsTicketsData] = React.useState("");
  const [reportsReviewTicketsData, setreportsReviewTicketsData] =
    React.useState("");

  const [ReportsTicketsTotalCountsData, setReportsTicketsTotalCountsData] =
    React.useState<any>("");
  const [ReportsTicketsRaisedData, setReportsTicketsRaisedData] =
    React.useState("");

  const [DevicesData, setDevicesData] = React.useState("");
  const [MostReferedArticlesData, setMostReferedArticlesData] =
    React.useState("");

  const [ReportsTicketsTopfiveCount, setReportsTicketsTopfiveCount] =
    React.useState(0);

  const [selectedProVerDataType, setselectedProVerDataType] =
    React.useState("confirm");
  const [csvData, setCsvData] = React.useState<any>([]);
  const csvLinkRef = useRef<any>(null);
  const [exportSelectopen, setexportSelectopen] = React.useState(false);
  const [detectRefresh, setDetectRefresh] = React.useState(0);
  const [chatFallRateData, setChatFallRateData] = React.useState("");
  const [chatCsatData, setChatCsatData] = React.useState("");
  const [chatAvgResponseTimeData, setChatAvgResponseTimeData] =
    React.useState("");
  const [kbFeedbackGraphData, setKbFeedbackGraphData] = React.useState<any>("");
  const [preAIFeedbackGraphData, setPreAIFeedbackGraphData] =
    React.useState<any>("");

  // setContextMetricPageEndDate,
  const getUTCDate = (dateValue: any) => {
    const utcDate = new Date(parseInt(dateValue, 10));
    return utcDate;
  };
  useEffect(() => {
    setContextMetricPageStartDate(startDateValue);
    setContextMetricPageEndDate(endDateValue);
  }, [startDateValue, endDateValue]);

  useEffect(() => {
    if (selectedProVerDataType == "confirm" && selectedProVerData.length > 0) {
      fetchLoctionsData();
      fetchReportsTicketsTotalCountsData();
      fetchReportsTicketsRaisedData();
      fetchDevicesData();
      fetchMostReferedArticlesData();
      fetchReportsTicketsFeedbackGraphData();
      fetchAvgResponseTime(),
        fetchCsat(),
        fetchDropRate(),
        // fetchReportReviewCategories();
        resetcsmpaginationdata();
      // fetchAIAssistUsage();
      // fetchticketChannels();
      // fetchTicketsStatuses();
      setIsLoading(true);
    }
  }, [product, version, selectedProVerDataType]);

  useEffect(() => {
    if (product && version && proVerUrl) {
      if (
        (startDateValue && endDateValue) ||
        (startDateValue === null && endDateValue === null)
      ) {
        fetchLoctionsData();
        fetchReportsTicketsTotalCountsData();
        fetchReportsTicketsRaisedData();
        fetchDevicesData();
        fetchMostReferedArticlesData();
        fetchReportsTicketsFeedbackGraphData();
        fetchAvgResponseTime(),
          fetchCsat(),
          fetchDropRate(),
          // fetchReportReviewCategories();
          setIsLoading(true);
      }
    }
  }, [startDateValue, endDateValue, detectRefresh]);

  useEffect(() => {
    setFilterDate({
      startDate: startDateValue,
      endDate: endDateValue,
    });
  }, [endDateValue]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "dashboard",
        fileName: "index.tsx",
        filterDate: filterDate,
      },
    });
  }, [filterDate]);

  const changeStartDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(0, 0, 0, 0);
    const timestamp = dt.getTime();
    setStartDateValue(timestamp);
    setContextMetricPageStartDate(timestamp);
    appLogger.info({
      infoObj: {
        method: "changeStartDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
    if (timestamp > endDateValue) {
      setEndDateValue(null);
      setContextMetricPageEndDate(null);
    }
  };

  const changeEndDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(23, 59, 59, 999);
    const timestamp = dt.getTime();
    setEndDateValue(timestamp);
    setContextMetricPageEndDate(timestamp);

    appLogger.info({
      infoObj: {
        method: "changeEndDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      productResponse.length < 1
    ) {
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            response &&
              response.productNameList &&
              response.productNameList.length > 0 &&
              response.productNameList.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                productResponse: response,
              },
            });
            setProductResponse(response.productNameList);
            setProduct(ProVersion.product || response.productNameList[0].id);
            setVersion(
              ProVersion.version || response.productNameList[0].version
            );
            setSelectedProduct(response.productNameList[0]);

            setProVersion({
              product: ProVersion.product || response.productNameList[0].id,
              version:
                ProVersion.version || response.productNameList[0].version,
            });
            let tempurl = "";
            if (
              Array.isArray(contextProVersion) &&
              contextProVersion.length > 0
            ) {
              setcontextProVersion(contextProVersion);
              setselectedProVerData(contextProVersion);
              contextProVersion &&
                contextProVersion.length > 0 &&
                contextProVersion.map((data: any) => {
                  tempurl += `&prodId=${data.value}&prodVersion=${data.version}`;
                });
              setproVerUrl(tempurl);
            } else {
              setselectedProVerData([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                },
              ]);
              setcontextProVersion([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                  proversion:
                    response.productNameList[0].name +
                    response.productNameList[0].version,
                },
              ]);
              tempurl = `&prodId=${response.productNameList[0].id}&prodVersion=${response.productNameList[0].version}`;
              setproVerUrl(tempurl);
            }
            setIsLoading(false);
          } else {
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                userInfo: userInfo,
              },
            });
            setIsLoading(false);
            if (
              !contextRedirectProdPage &&
              (userInfo?.userDetails?.userRole == ROLE_USER_SUPERADMIN ||
                userInfo?.userDetails?.userRole == ROLE_USER_MANAGER ||
                userInfo?.userDetails?.userRole == ROLE_USER_ADMIN)
            ) {
              // navigate("/products");
            }
            // props.snackbarShowMessage("No products created in your organization. Create a product first", "error");
            // setTimeout(() => {
            //   navigate("/add-product")
            // }, 2000);
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          setIsLoading(false);
        });
    }
  }, [userInfo]);

  const fetchLoctionsData = () => {
    if (proVerUrl) {
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/chatbotmetrics/Location?${proVerUrl}${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          setReportsTicketsData(response.topics);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };
  const resetcsmpaginationdata = () => {
    // setcsmPage(1);
    // setHascsmMore(true);
    // setReportsTicketsRaisedData([]);
  };

  const fetchReportReviewCategories = () => {
    if (proVerUrl) {
      const datewiseFilter = `&from=${
        startDateValue ? startDateValue : ""
      }&to=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/correlation/playstoreChart?${proVerUrl}&items=5`,
        state: userInfo,
      })
        .then((response: any) => {
          setreportsReviewTicketsData(response.topics);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchReportsTicketsRaisedData = () => {
    // Assuming the timestamp is in milliseconds
    // const startDate = new Date(startDateValue);
    // startDate.setHours(0, 0, 0, 0);
    // const endDate = new Date(endDateValue);
    // endDate.setHours(23, 59, 59);

    if (proVerUrl) {
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;

      Http.get({
        url: `/api/v2/chart/BUG_REPORT?${proVerUrl}&xAxisData=DateTime${datewiseFilter}&agent=CHAT_AGENT`,
        state: userInfo,
      })
        .then((response: any) => {
          setReportsTicketsRaisedData(response);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchReportsTicketsTotalCountsData = () => {
    if (proVerUrl) {
      setIsChatbotMetricsLoading(true);
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/chatbotmetrics/BotMessageCount?${proVerUrl}${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          setReportsTicketsTotalCountsData(response);
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchReportsTicketsFeedbackGraphData = () => {
    if (proVerUrl) {
      setIsChatbotMetricsLoading(true);
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/chatbotmetrics/ChatFeedback?${proVerUrl}${datewiseFilter}&aiType=KB`,
        state: userInfo,
      })
        .then((response: any) => {
          setKbFeedbackGraphData(response.chatFeedback);
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
    if (proVerUrl) {
      setIsChatbotMetricsLoading(true);
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/chatbotmetrics/ChatFeedback?${proVerUrl}${datewiseFilter}&aiType=preAI`,
        state: userInfo,
      })
        .then((response: any) => {
          setPreAIFeedbackGraphData(response.chatFeedback);
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchDropRate = () => {
    if (proVerUrl) {
      setIsChatbotMetricsLoading(true);
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/chatbotmetrics/ChatFallRate?${proVerUrl}${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          setChatFallRateData(response?.chatFallRatePercentage);
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchCsat = () => {
    if (proVerUrl) {
      setIsChatbotMetricsLoading(true);
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/chatbotmetrics/ChatCsat?${proVerUrl}${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          setChatCsatData(response?.chatCsat);
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchAvgResponseTime = () => {
    if (proVerUrl) {
      setIsChatbotMetricsLoading(true);
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/chatbotmetrics/ChatAvgResponseTime?${proVerUrl}${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          setChatAvgResponseTimeData(response?.chatAvgResponseTime);
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchDevicesData = () => {
    if (proVerUrl) {
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/chatbotmetrics/Platform?${proVerUrl}${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.platformDetails &&
            response.platformDetails.length > 0
          ) {
            setDevicesData(response.platformDetails);
            setReportsTicketsTopfiveCount(response.Items.Count);
          } else {
            setDevicesData(response.platformDetails);
            setReportsTicketsTopfiveCount(response.Items.Count);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchMostReferedArticlesData = () => {
    if (proVerUrl) {
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/chatbotmetrics/KBArticle?${proVerUrl}${datewiseFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.kbArticles &&
            response.kbArticles.length > 0
          ) {
            setMostReferedArticlesData(response.kbArticles);
          } else {
            setMostReferedArticlesData(response.kbArticles);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };

  const selectedProVerDataFn = (selectedProVerData: any, type: any) => {
    let getData = selectedProVerData;
    getData = selectedProVerData;
    setselectedProVerData(selectedProVerData);

    HandleContextSelectedProVer(getData);
    setselectedProVerData(getData);
    let tempproVerUrl = "";
    getData &&
      getData.length > 0 &&
      getData.map((data: any) => {
        tempproVerUrl += `&prodId=${data.value}&prodVersion=${data.version}`;
      });
    setproVerUrl(tempproVerUrl);
    setselectedProVerDataType(selectedProVerData.type);
  };
  const HandleContextSelectedProVer = (data: any) => {
    setcontextProVersion(data);
  };

  const clearDate = () => {
    setDetectRefresh((prev) => prev + 1);
    // setStartDateValue(stDateTimestamp);
    // setEndDateValue(currDateTimestamp);
    // setFilterDate({
    //   startDate: currDateTimestamp,
    //   endDate: currDateTimestamp,
    // });
  };

  const renderNoProductMessage = () => {
    let res = <></>;
    if (productResponse.length == 0 && !isLoading) {
      res = <NoProductMessage />;
    }
    return res;
  };

  const renderColor = (val: number) => {
    let colour = "";
    if (val >= 0 && val < 1) {
      colour = "#e51919";
    } else if (val >= 1 && val < 2) {
      colour = "#f97b28";
    } else if (val >= 2 && val < 3) {
      colour = "#f4c51a";
    } else if (val >= 3 && val < 4) {
      colour = "#76d43b";
    } else if (val >= 4 && val <= 5) {
      colour = "#028128";
    }
    return colour;
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  // const handleexportClose = () => {
  //   setexportSelectopen(false);
  // };
  // const handleeportOpen = () => {
  //   setexportSelectopen(true);
  // };

  const [downloadReady, setDownloadReady] = React.useState(false);

  const dataFromListOfUsersState = () => {
    return csvData;
  };

  const workbook = new Excel.Workbook();

  const columns = [
    { header: "Session ID", key: "sessionId" },
    { header: "Start Time", key: "startTime" },
    { header: "End Time", key: "endTime" },
    { header: "Human Message", key: "human" },
    { header: "Bot Message", key: "chatbot" },
    { header: "Platform Name", key: "platformName" },
    { header: "Account Name", key: "productName" },
    { header: "Account ID and Version", key: "productId" },
    { header: "Prompted To Raise Ticket", key: "promptedToRaiseTicket" },
    { header: "Jira Ticket", key: "jiraUrl" },
    { header: "Zendesk Ticket", key: "zendeskUrl" },
    { header: "User Feedback", key: "userFeedback" },
    { header: "Response Type", key: "responseType" },
  ];
  const csvColumns = [
    { label: "Session ID", key: "sessionId" },
    { label: "Start Time", key: "startTime" },
    { label: "End Time", key: "endTime" },
    { label: "Human Message", key: "human" },
    { label: "Bot Message", key: "chatbot" },
    { label: "Platform Name", key: "platformName" },
    { label: "Account Name", key: "productName" },
    { label: "Account ID and Version", key: "productId" },
    { label: "Prompted To Raise Ticket", key: "promptedToRaiseTicket" },
    { label: "Jira Ticket", key: "jiraUrl" },
    { label: "Zendesk Ticket", key: "zendeskUrl" },
    { label: "User Feedback", key: "userFeedback" },
    { label: "Response Type", key: "responseType" },
  ];

  const fetchExportDataInBatches = async () => {
    const datewiseFilter = `&startDate=${
      startDateValue ? startDateValue : ""
    }&endDate=${endDateValue ? endDateValue : ""}`;
    let hasMoreData = true;
    let skip = 0;
    const limit = 10000;
    let chatDataForExport: any = [];

    // Get token
    const { token, orgId }: any = await Http.get({
      url: `/api/v2/chatbotmetrics/ExportChat?${proVerUrl}${datewiseFilter}`,
      state: userInfo,
    });

    if (!token) {
      props.snackbarShowMessage("Something went wrong!", "error", null);
      return;
    }

    const params = new URLSearchParams(proVerUrl);
    const prodId = params.getAll("prodId");
    const prodVersion = params.getAll("prodVersion");
    let index = 0;

    while (hasMoreData) {
      try {
        const response: any = await fetch(
          `${ec2HostURL}/api/exportChat?token=${token}&orgId=${orgId}&prodId=${prodId[index]}&prodVersion=${prodVersion[index]}&skip=${skip}&limit=${limit}`
        );
        const excelData = await response.json();

        if (excelData?.chatData?.length === limit) {
          skip = skip + limit;
        } else {
          if (index < prodId.length - 1) {
            index++;
            skip = 0;
          } else {
            hasMoreData = false;
          }
        }

        if (excelData?.chatData?.length) {
          chatDataForExport = [...chatDataForExport, ...excelData.chatData];
        }
      } catch (error) {
        props.snackbarShowMessage("Something went wrong!", "error", null);
        hasMoreData = false;
        return;
      }
    }

    return chatDataForExport;
  };

  const saveAsExcel = async () => {
    setIsLoading(true);
    const chatDataForExport = await fetchExportDataInBatches();

    if (!chatDataForExport?.length) {
      return setIsLoading(false);
    }

    // Format data
    chatDataForExport.forEach((chat: any) => {
      chat["sessionId"] = chat?.sessionId || "";
      chat["startTime"] = chat?.startTime || "";
      chat["endTime"] = chat?.endTime || "";
      chat["human"] = chat?.human || "";
      chat["chatbot"] = chat?.chatbot || "";
      chat["platformName"] = chat?.platformName || "";
      chat["productName"] = chat?.productName || "";
      chat["productId"] = chat?.productId
        ? chat.productId + "/" + chat.productVersion
        : "";
      chat["promptedToRaiseTicket"] = chat?.promptedToRaiseTicket
        ? "TRUE"
        : "FALSE";
      chat["jiraUrl"] = chat?.jiraUrl || "";
      chat["zendeskUrl"] = chat?.zendeskUrl || "";
      chat["userFeedback"] = chat?.userFeedback || "";
      chat["responseType"] = chat?.responseType || "";
    });

    try {
      // const fileName = EXPORT_NAME;
      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet("Worksheet-1");
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;
      // updated the font for first row.
      worksheet.getRow(1).font = { bold: true };
      // loop through all of the columns and set the alignment and width.
      worksheet.columns.forEach((column) => {
        column.width = 45;
        column.alignment = { horizontal: "left" };
      });
      // loop through data and add each one to worksheet
      chatDataForExport.forEach((singleData: any) => {
        worksheet.addRow(singleData);
      });

      // loop through all of the rows and set the outline style.
      worksheet.eachRow({ includeEmpty: false }, (row: Excel.Row) => {
        // loop through the non-empty cells in each row to apply border
        row.eachCell((cell) => {
          // apply border
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });

      // write the content using writeBuffer
      const buf = await workbook.xlsx.writeBuffer();
      // download the processed file
      const currentTime = new Date().toISOString();
      const withoutMillisec = currentTime.replace(/\.\d+Z$/, "");
      const fileName = "Chat_Export_";
      saveAs(new Blob([buf]), `${fileName}${withoutMillisec}.xlsx`);
      setexportSelectopen(false);
    } catch (error) {
      setexportSelectopen(false);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet("Worksheet-1");
      setexportSelectopen(false);
      setIsLoading(false);
    }
  };

  const saveAsCSV = async () => {
    setIsLoading(true);
    const chatDataForExport = await fetchExportDataInBatches();

    if (!chatDataForExport?.length) {
      return setIsLoading(false);
    }

    // Format data
    chatDataForExport.forEach((chat: any) => {
      chat["sessionId"] = chat?.sessionId || "";
      chat["startTime"] = chat?.startTime || "";
      chat["endTime"] = chat?.endTime || "";
      chat["human"] = chat?.human?.replace(/"/g, '""') || "";
      chat["chatbot"] = chat?.chatbot?.replace(/"/g, '""') || "";
      chat["platformName"] = chat?.platformName || "";
      chat["productName"] = chat?.productName || "";
      chat["productId"] = chat?.productId
        ? chat.productId + "/" + chat.productVersion
        : "";
      chat["promptedToRaiseTicket"] = chat?.promptedToRaiseTicket
        ? "TRUE"
        : "FALSE";
      chat["jiraUrl"] = chat?.jiraUrl || "";
      chat["zendeskUrl"] = chat?.zendeskUrl || "";
      chat["userFeedback"] = chat?.userFeedback || "";
      chat["responseType"] = chat?.responseType || "";
    });

    setCsvData(chatDataForExport);
    setTimeout(() => {
      csvLinkRef.current.link.click();
    }, 100);
    setIsLoading(false);
  };

  const saveAsJSON = async () => {
    try {
      setIsLoading(true);
      let chatDataForExport = await fetchExportDataInBatches();

      if (!chatDataForExport?.length) {
        return setIsLoading(false);
      }

      // Format data
      chatDataForExport = chatDataForExport.map((chat: any) => ({
        "Session ID": chat?.sessionId || "",
        "Start Time": chat?.startTime || "",
        "End Time": chat?.endTime || "",
        "Human Message": chat?.human || "",
        "Bot Message": chat?.chatbot || "",
        "Platform Name": chat?.platformName || "",
        "Account Name": chat?.productName || "",
        "Account ID and Version": chat?.productId
          ? chat.productId + "/" + chat.productVersion
          : "",
        "Prompted To Raise Ticket": chat?.promptedToRaiseTicket
          ? "TRUE"
          : "FALSE",
        "Jira Ticket": chat?.jiraUrl || "",
        "Zendesk Ticket": chat?.zendeskUrl || "",
        "User Feedback": chat?.userFeedback || "",
        "Response Type": chat?.responseType || "",
      }));

      const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
        JSON.stringify(chatDataForExport)
      )}`;
      const link = document.createElement("a");
      link.href = jsonString;

      const timestampWithoutMS = new Date()
        .toISOString()
        .replace(/\.\d+Z$/, "");
      link.download = `Chat_Export_${timestampWithoutMS}.json`;

      // Remove the link from the DOM after the download is completed
      link.addEventListener("click", () => {
        link.remove();
      });

      link.click();
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: any) => {
    if (ReportsTicketsTotalCountsData.totalMessageCount > 200000) {
      const errorMessage =
        "Too many records to export. Please select a narrower date range to keep the number of messages less than 200k";
      props.snackbarShowMessage(errorMessage, "error", null);
      return;
    }

    props.snackbarShowMessage(
      "Please wait while we export your data. This might take a few minutes!",
      "success",
      5000
    );

    const value = e.target.value;
    if (value == "xls") {
      void saveAsExcel();
    } else if (value == "CSV") {
      void saveAsCSV();
    } else {
      void saveAsJSON();
    }
  };

  useEffect(() => {
    //    //define the heading for each row of the data
    // var csv = 'Name,Profession\n';

    // //merge the data with CSV
    // csvFileData.forEach(function(row) {
    //         csv += row.join(',');
    //         csv += "\n";
    // });

    // //display the created CSV data on the web browser
    // document.write(csv);

    // var hiddenElement = document.createElement('a');
    // hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    // hiddenElement.target = '_blank';

    // //provide the name for the CSV file to be downloaded
    // hiddenElement.download = 'Famous Personalities.csv';
    // hiddenElement.click();
    // var csvFile;
    // var downloadLink;

    // //define the file type to text/csv
    // csvFile = new Blob([csv], {type: 'text/csv'});
    // downloadLink = document.createElement("a");
    // downloadLink.download = filename;
    // downloadLink.href = window.URL.createObjectURL(csvFile);
    // downloadLink.style.display = "none";

    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    if (csvLinkRef && csvLinkRef.current && downloadReady) {
      csvLinkRef.current.link.click();
      setDownloadReady(false);
    }
  }, [downloadReady]);

  const getExportFileName = () => {
    const currentTime = new Date().toISOString();
    const withoutMillisec = currentTime.replace(/\.\d+Z$/, "");
    const fileName = "Chat_Export_";
    // console.log(`${fileName}${withoutMillisec}.xlsx`, "fileName");
    return `${fileName}${withoutMillisec}.csv`;
  };

  const getDateString = (timestamp: any) => {
    const dt = new Date(timestamp);
    const year = dt.getFullYear();
    const month = String(dt.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(dt.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <Grid
      className={
        isLoading || isChatbotMetricsLoading
          ? " chart-item loader"
          : "chart-item"
      }
    >
      {renderNoProductMessage()}
      <Grid className="feedback-bug-filter" container sx={{ mb: 2 }}>
        <Grid
          xs={12}
          sm={12}
          md={12}
          lg={4}
          xl={4}
          className="pro-ver-dropdown-grid"
        >
          {/* <Grid item xs={6} sm={4} lg={6} className="pro-ver-dropdown-grid"> */}

          <ProductVersionDropdown
            productResponse={productResponse}
            selectedProVerData={selectedProVerData}
            selectedProVerDataFn={selectedProVerDataFn}
            contextProVersion={contextProVersion}
            type="cuvo-metrics"
          />
        </Grid>
        <Grid className="article-startdate" item xs={5} sm={4} md={4} lg={1.5}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-start"
              label="Start Date"
              type="date"
              value={startDateValue ? getDateString(startDateValue) : ""}
              onChange={changeStartDateValue}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                max: currDate.toISOString().slice(0, 10),
              }}
            />
          </Box>
        </Grid>
        &nbsp;
        <Grid item xs={5} sm={4} md={4} lg={1.5}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-end"
              label="End Date"
              type="date"
              value={endDateValue ? getDateString(endDateValue) : ""}
              onChange={changeEndDateValue}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                min: getDateString(startDateValue),
                max: currDate.toISOString().slice(0, 10),
              }}
            />
          </Box>
        </Grid>
        <Grid
          item
          xs={5}
          sm={4}
          md={3}
          lg={2.3}
          className="clear-option"
          title="Refresh"
        >
          {startDateValue || endDateValue ? (
            <RefreshIcon onClick={clearDate} />
          ) : (
            <RefreshIcon onClick={clearDate} />
          )}
        </Grid>
        <Grid item className="export-chat-select-btn" spacing={1}>
          <CSVLink
            data={csvData}
            headers={csvColumns}
            asyncOnClick={true}
            // onClick={(e: any) => saveCsv()}
            // filename={`${"Chat_Export_"}${new Date().toISOString()}.csv`}
            filename={getExportFileName()}
            ref={csvLinkRef}
          ></CSVLink>
          <FormControl sx={{ minWidth: 130 }} size="small">
            <Select
              disabled={
                ReportsTicketsTotalCountsData &&
                ReportsTicketsTotalCountsData.totalMessageCount > 0
                  ? false
                  : true
              }
              // onClose={handleexportClose}
              // onOpen={handleeportOpen}
              // open={exportSelectopen}
              className="export-chat-select"
              style={{
                background: "#0157ff",
                color: "#fff",
                opacity:
                  ReportsTicketsTotalCountsData &&
                  ReportsTicketsTotalCountsData.totalMessageCount > 0
                    ? 1
                    : 0.5,
              }}
              sx={{
                textAlign: "center",
                fontSize: "13px",
                ".MuiOutlinedInput-notchedOutline": {
                  border: 1,
                  borderColor: "#0157ff",
                  color: "#fff",
                },
                "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                  {
                    border: 1,
                    borderColor: "#0157ff",
                    color: "#fff",
                  },
                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    border: 1,
                    borderColor: "#0157ff",
                    color: "#fff",
                  },
                ".MuiSvgIcon-root ": {
                  fill: "white !important",
                },
              }}
              displayEmpty
              inputProps={{
                "aria-label": "Without label",
                MenuProps: {
                  PaperProps: {
                    sx: {},
                  },
                },
              }}
              value="Export Chat"
              onChange={handleInputChange}
            >
              <MenuItem
                key={1}
                value={"Export Chat"}
                sx={{ display: "none", justifyContent: "center" }}
              >
                Export Chat
              </MenuItem>
              <MenuItem key={2} value={"xls"}>
                <img
                  style={{
                    height: "15px",
                    width: "15px",
                    marginRight: "5px",
                  }}
                  src={images.xlsxsvg}
                />
                Export as xlsx
              </MenuItem>
              <MenuItem key={3} value={"CSV"}>
                <img
                  style={{
                    height: "15px",
                    width: "15px",
                    marginRight: "5px",
                  }}
                  src={images.csvsvg}
                />
                Export as csv
              </MenuItem>
              <MenuItem key={4} value={"JSON"}>
                <img
                  style={{
                    height: "15px",
                    width: "15px",
                    marginRight: "5px",
                  }}
                  src={images.json}
                />
                Export as json
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <ChatMetricsTileCount
              ReportsTicketsRaisedData={ReportsTicketsRaisedData}
              ReportsTicketsTotalCountsData={ReportsTicketsTotalCountsData}
              isChatbotMetricsLoading={isChatbotMetricsLoading}
            />
          </Grid>
        </Grid>
        {/* <Grid item xs={4}>
          <ReportNewArrivalTickets
            Topfivetickets={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={9}
          xl={9}
          sx={{ height: "380px !important" }}
        >
          <ChatIssuesStatusChart
            startDateValue={startDateValue}
            endDateValue={endDateValue}
            Topfivetickets={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
            ReportsTicketsTotalCountsData={ReportsTicketsTotalCountsData}
            ReportsTicketsRaisedData={ReportsTicketsRaisedData}
          />
        </Grid>
        {/*   <Grid item xs={3}>
         <ChatTopTopics
            Topfivetickets={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          /> 
          <ChatLocation
            DevicesData={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
        </Grid> */}
        <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
          <ChatDevices
            DevicesData={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <ChatKBPerformance
            Topfivetickets={ReportsTicketsTopfive}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
        </Grid>*/}
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            <TickMetricAIAssist
              AIAssistUsage={chatFallRateData}
              ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            <TickMetricFirstResponse
              chatCsatData={chatCsatData}
              ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            <TickMetricMeanTimeResolution
              chatAvgResponseTimeData={chatAvgResponseTimeData}
              ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
            />
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={6}
          sx={{ height: "380px !important" }}
        >
          <ChatBotKBEffiencyGraph
            preAIFeedbackGraphData={preAIFeedbackGraphData}
            kbFeedbackGraphData={kbFeedbackGraphData}
            startDateValue={startDateValue}
            endDateValue={endDateValue}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Box className="chart-item ratings-chart">
            <ChatMetricIssuesTable
              title="Most Referred Articles"
              time="3"
              feedbacks={feedbacks}
              MostReferedArticlesData={MostReferedArticlesData}
            />
          </Box>
        </Grid>
        {/* <Grid item xs={6}>
          <ChatMetricIssuesTable
            title="Improvement Opportunities"
            time="3"
            feedbacks={feedbacks}
            reportsTicketsData={reportsTicketsData}
          />
        </Grid> */}
      </Grid>
      {/* <Grid container item xs={12} spacing={3}>
        <Grid item xs={8} spacing={3}>
          <Grid container spacing={1}>
            <ChatMetricsTileCount
              ReportsTicketsTotalCountsData={ReportsTicketsTotalCountsData}
            />
          </Grid>
          <Grid container mt={2}>
            <Grid item xs={12}>
              <FeedbackMetric
                title="TICKET CATEGORIES"
                time="3"
                feedbacks={feedbacks}
                reportsTicketsData={reportsTicketsData}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <ReportNewArrivalTickets
            Topfivetickets={ReportsTicketsTopfive}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
          <br></br>
        </Grid>
        <Grid container item spacing={3}>
          <Grid item xs={12}>
            <ReviewCategoriesMetric
              title="REVIEW CATEGORIES"
              time="3"
              reportsReviewTicketsData={reportsReviewTicketsData}
              // reportsTicketsData={reportsTicketsData}
            />
          </Grid>
        </Grid>
      </Grid> */}
    </Grid>
  );
}

export default withSnackbar(ReportsTicketsDashboardContent);
